import { Chip, tooltipClasses } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { createElement } from "react";
import { TbQrcode } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { shiftTypeStatuses } from "@/constants/shiftTypeStatuses";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { User, UserExtras, UserType } from "@/types/user.types";

function RenderCell({ value, userType }: { userType: UserType; value: UserExtras }) {
    const canDoShiftWithoutQr = shiftTypeStatuses.find((item) => item.cond(userType, value));
    return (
        <div className="flex items-center py-1 h-full">
            {canDoShiftWithoutQr && (
                <NoMaxWidthTooltip
                    arrow
                    sx={{
                        [`& .${tooltipClasses.tooltip}`]: {
                            backgroundColor: "white",
                            border: "none",
                            padding: "0px !important",
                            fontSize: 12,
                            maxWidth: "200px !important",
                        },
                    }}
                    title={<HotelStatusTooltip status={canDoShiftWithoutQr} />}
                >
                    <Chip
                        sx={{
                            backgroundColor: canDoShiftWithoutQr.bg,
                            color: canDoShiftWithoutQr.text,
                            fontWeight: 500,
                            fontSize: "12px !important",
                        }}
                        icon={createElement(canDoShiftWithoutQr.component(), {
                            fontSize: 14,
                            color: canDoShiftWithoutQr.text,
                        })}
                        label={canDoShiftWithoutQr.label}
                    />
                </NoMaxWidthTooltip>
            )}
        </div>
    );
}

export const UserShiftTypeColumn = ({ t }: { t: TFunction }): GridColDef<User> => {
    return {
        field: "extras",
        headerName: t("shiftType"),
        minWidth: 180,
        valueGetter: (_val, row) => row.extras,
        renderHeader: (params) => <TableHeader Component={TbQrcode} title={params.colDef.headerName!} />,
        renderCell: ({ value, row }) => <RenderCell userType={row.userType} value={value} />,
    };
};
export default UserShiftTypeColumn;
